import ShipmentPosition from '../../../types/api/shipment-position'

/** Тираж позиции для отображения: факт после фиксации расхода, иначе план. */
export function getShipmentPositionDisplayCopies(
    position: Pick<ShipmentPosition, 'copies' | 'actualCopies'>
): number {
    return Number(position.actualCopies ?? position.copies) || 0
}

export function getShipmentDisplayCopiesSum(
    positions?: Pick<ShipmentPosition, 'copies' | 'actualCopies'>[] | null
): number {
    return (positions ?? []).reduce(
        (sum, position) => sum + getShipmentPositionDisplayCopies(position),
        0
    )
}
